<template>
    <div class="scroller" @touchstart="onTouchStart" @touchend="onTouchEnd" @touchmove="onTouchMove">
        <div class="slides" ref="slider" @wheel="throttledScroll">
            <component v-for="( item, i ) of flattenPages" :key="i" class="slide" :is="item" :meta="item.meta" :data-child-of="item.meta.childOf" @openOverlay="openOverlay">{{ i + ' - ' + item.title }}</component>
        </div>
        <navigation :index="index" :items="flattenPages" @update="scrollTo(true)"></navigation>

        <scroll-indicator class="prev" :color="currentMeta.color" @click="go( -1, true )" v-show="index > 0"></scroll-indicator>
        <home-indicator :color="currentMeta.color" @click="toTop()" v-show="index > 0"></home-indicator>
        <scroll-indicator :color="currentMeta.color" @click="go( +1, true )" v-show="index < maxIndex"></scroll-indicator>

        <transition name="fade">
            <overlay v-if="subPage" @close="closeOverlay()">
                <component :is="subPage" @close="closeOverlay()"></component>
            </overlay>
        </transition>
    </div>
</template>

<style lang="scss">
</style>

<script>
    import gsap from 'gsap';
    import { Lethargy } from 'lethargy';

    import { domUtils } from '@/app/mixins';

    import Navigation from '@/app/components/Navigation.vue';
    import ScrollIndicator from '@/app/components/ScrollIndicator.vue';
    import HomeIndicator from '@/app/components/HomeIndicator.vue';
    import Overlay from '@/app/components/Overlay.vue';

    const lethargy = new Lethargy(); // new Lethargy( 7, 50, 0.05 );

    export default {
        name: 'Scroller',

        components: {
            overlay: Overlay,
            navigation: Navigation,
            ScrollIndicator: ScrollIndicator,
            HomeIndicator: HomeIndicator
        },

        mixins: [ domUtils ],

        props: {
            pages: {
                type: Array,
                default: () => []
            }
        },

        data()
        {
            return {
                subPage: null
            };
        },

        computed: {
            flattenPages()
            {
                let slides = [];
                for( let page in this.pages )
                {
                    /* eslint-disable-next-line */
                    this.pages[ page ].meta.index = slides.length;
                    let startingIndex = slides.length;

                    slides.push( this.pages[ page ] );
                    if( !this.pages[ page ] )
                    {
                        continue;
                    }

                    // starting index = slides.length
                    // starting index moet verderop gebruikt worden

                    for( let i in this.pages[ page ].meta.slides )
                    {
                        /* eslint-disable-next-line */
                        this.pages[ page ].meta.slides[ i ].meta.childOf = this.pages[ page ].name;
                        /* eslint-disable-next-line */
                        this.pages[ page ].meta.slides[ i ].meta.index = slides.length; // dit moet een index zijn, maar omdat we nog een array aan het bouwen zijn hier, is de length dus de index, ofzo. Hier slides.length is iig niet goed, (of toch wel...?)

                        /* eslint-disable-next-line */
                        this.pages[ page ].meta.slides[ i ].meta.parentIndex = startingIndex;

                        slides.push( this.pages[ page ].meta.slides[ i ] );
                    }
                }
                return slides;
            },
            index()
            {
                // console.log( 'new index', this.$store.getters.index ); // index van de slide
                return this.$store.getters.index;
            },
            currentMeta()
            {
                // console.log( 'meta', this.flattenPages[ this.index ].meta ); // meta van de section pagina
                // console.log( this.index );
                return this.flattenPages[ this.index ].meta;
            },
            maxIndex()
            {
                return this.flattenPages.length - 1;
            }
        },

        watch: {
            '$route.params'( val )
            {
                this.onRoute( val );
            }
        },

        created()
        {
            // console.log( 'created' );
            this.keyListener = this.onKey.bind( this );
            window.addEventListener( 'keyup', this.keyListener );

            this.visitedPages = [];
        },
        destroyed()
        {
            // console.log( 'destroyed' );
            window.removeEventListener( 'keyup', this.keyListener );
        },

        mounted()
        {
            this.scrollListening = true;

            this.mapElement = document.querySelector( '#map' );

            this.onRoute( this.$route.params );

            this.scrollTo();

            console.log( this.flattenPages );
        },

        methods: {
            onRoute( val )
            {
                // console.log( 'has keepindex:', this.keepIndex );

                let to = 0;
                if( this.keepIndex )
                {
                    // console.log( this.keepIndex );
                    to = this.keepIndex;
                    this.keepIndex = undefined;
                }
                else
                {
                    for( let i = 0; i < this.flattenPages.length; i++ )
                    {
                        if( this.flattenPages[ i ].name === val.name )
                        {
                            to = i;
                        }
                    }
                    this.currentPath = '/' + this.flattenPages[ to ].name;
                }

                this.$store.dispatch( 'index', to );
                this.scrollTo();

                // this or check is wrong
                // console.log( 'heeft een route een sub:', val.sub );
                // console.log( 'deze slide heeft een $attrs:', this.$children[ this.index ].$attrs.meta );
                // Michrl i hier verantwoordelij kvoor
                let theIndex = this.$children[ this.index ].$attrs.meta && this.$children[ this.index ].$attrs.meta.parentIndex ? this.$children[ this.index ].$attrs.meta.parentIndex : this.index;

                // theIndex is dus niet de index waar het interview bij hoort,
                // theIndex is de index van de parent van de parent van het interview (title slide van de sectie)
                // console.log( 'de parent slide van deze index is deze:', theIndex );

                // console.log( this.$children, this.index );

                if( val.sub || this.$children[ theIndex ].sub )
                {
                    // console.log( 'calling sub on', this.$children[this.index], val.sub );
                    this.$children[ theIndex ].sub( val.sub );
                }
                else
                {
                    // console.log( 'ELS?!', to );
                    this.keepIndex = to;
                    this.subPage = null;
                }

                if( !val.sub && this.subPage !== null )
                {
                    this.closeOverlay();
                }
            },
            throttledScroll( e )
            {
                /* let power = Math.ceil( e.deltaY / 100 );
                if( power > this.scrollPower )
                {
                    this.scrollPower = power;
                }
                clearTimeout( this.scrollThrottle );
                this.scrollThrottle = setTimeout( () =>
                {
                    this.go( power );
                    this.scrollPower = 0;
                }, 50 ); */
                e.preventDefault();
                e.stopPropagation();

                // console.log( 'target', e.target );
                // console.log( 'currentTarget', e.currentTarget );

                let isChildOfMap = this.isDescendant( e.target, this.mapElement );
                if( isChildOfMap )
                {
                    return;
                }

                let power = lethargy.check( e );
                if( power !== false )
                {
                    // Do something with the scroll event
                    if( this.scrollListening )
                    {
                        this.go( power > 0 ? -1 : 1 );
                        this.scrollPower = 0;
                        this.scrollListening = false;
                        clearTimeout( this.ts );
                        this.ts = setTimeout( () =>
                        {
                            this.scrollListening = true;
                        }, 500 );
                    }
                }
            },

            onKey( e )
            {
                e.stopPropagation();
                switch( e.key )
                {
                    case ' ':
                    case 'ArrowDown':
                    case 'PageDown':
                        this.go( +1 );
                        break;
                    case 'ArrowUp':
                    case 'PageUp':
                        this.go( -1 );
                        break;
                }
            },

            onTouchStart( e )
            {
                const touch = e.changedTouches[0];
                this.startTouchX = touch.pageX;
                this.startTouchY = touch.pageY;
                this.startTouchTime = new Date().getTime();
            },
            onTouchMove( e )
            {
                e.preventDefault();
            },
            onTouchEnd( e )
            {
                if( this.subPage )
                {
                    return;
                }
                const touch = e.changedTouches[0];
                const distX = touch.pageX - this.startTouchX;
                const distY = touch.pageY - this.startTouchY;
                const absX = Math.abs( distX );
                const absY = Math.abs( distY );
                const elapsedTime = new Date().getTime() - this.startTouchTime;
                if( elapsedTime > 300 )
                {
                    return;
                }

                switch( true )
                {
                    case absY >= 150 && absY > absX && distY < 0:
                        this.go( +1 );
                        e.preventDefault();
                        break;
                    case absY >= 150 && absY > absX && distY > 0:
                        this.go( -1 );
                        e.preventDefault();
                        break;
                }
            },

            toTop()
            {
                this.$store.dispatch( 'index', 0 );
                this.scrollTo( true, true );
            },

            go( direction, slower )
            {
                this.$store.dispatch( 'index', Math.max( 0, Math.min( this.maxIndex, this.index + direction ) ) );
                this.scrollTo( true, slower );
            },

            onNavigated()
            {
                // console.log( 'onNavigated', this.flattenPages[ this.index ].meta );

                // if meta (parent ref) has slides, update the current path
                if( ( this.flattenPages[ this.index ].meta.slides && this.flattenPages[ this.index ].meta.slides.length > 0 ) )
                {
                    // check the current name of the route, apply on the url
                    this.currentPath = '/' + this.flattenPages[ this.index ].name;

                    // reset the keepIndex because it's already a title slide
                    this.keepIndex = null;

                    if( this.$route.path === this.currentPath )
                    {
                        return;
                    }

                    this.$router.replace({ path: this.currentPath });
                }
                else if( this.flattenPages[this.index].meta.childOf )
                {
                    // if meta slide belongs to a different parent, update the current path.

                    // we need parent slide name and parent slide index
                    // every child needs to know its parent (belongsTo, belongsToIndex) so the url rewrite doesn't scroll back to the title page
                    this.currentPath = '/' + this.flattenPages[ this.index ].meta.childOf;
                    this.keepIndex = this.flattenPages[ this.index ].meta.index;

                    if( this.$route.path === this.currentPath )
                    {
                        return;
                    }

                    this.$router.replace({ path: this.currentPath });
                }
                else
                {
                    // console.log( 'didn\'t pass test' );
                }
            },

            scrollTo( smooth, slower )
            {
                if( this.currentIndex === this.index )
                {
                    return;
                }
                this.currentIndex = this.index;
                if( this.scrollAnim )
                {
                    this.scrollAnim.kill();
                }
                let y = -( window.innerHeight * this.index );
                if( smooth )
                {
                    this.scrollAnim = gsap.to( this.$refs.slider, slower ? 1 : 0.5, {
                        y,
                        onComplete: () =>
                        {
                            this.onFocus();
                            this.onNavigated();
                        }
                    });
                }
                else
                {
                    gsap.set( this.$refs.slider, { y });
                    this.onFocus();
                }
            },
            onFocus()
            {
                /* if( this.visitedPages.indexOf( this.index ) > -1 )
                {
                    return;
                } */

                // this.visitedPages.push( this.index );
                for( let i in this.$children )
                {
                    let type = parseInt( i, 10 ) === this.index ? 'focus' : 'blur';
                    if( this.$children[ i ][ type ] )
                    {
                        this.$children[ i ][ type ]();
                    }
                }
            },
            openOverlay( page, index )
            {
                // console.log( 'is de index wel echt 9?', index, ( index || this.index ) );
                this.subPage = page;
                this.keepIndex = index || this.index;

                if( this.$route.path !== this.currentPath + '/' + page.name )
                {
                    this.$router.push({ path: this.currentPath + '/' + page.name });
                }
            },
            closeOverlay()
            {
                // console.log( 'hallo? close overlay?', this.keepIndex, this.index );
                this.subPage = null;
                this.keepIndex = this.keepIndex || this.index;

                if( this.$route.path !== this.currentPath )
                {
                    this.$router.replace({ path: this.currentPath });
                }
            }
        }
    };
</script>
